import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/pages/login/routes'
import Register from '@/pages/register/routes'
import ForgotPassword from '@/pages/forgot-password/routes'
import MaintenanceRoutes from '@/pages/login/maintenance-routes'
import Home from '@/pages/home/routes'
import ScanQR from '@/pages/scan-qr/routes'
import Charger from '@/pages/charger/routes'
import Charging from '@/pages/charging/routes'
import Explore from '@/pages/explore/routes'
import Activity from '@/pages/activity/routes'
import Profile from '@/pages/profile/routes'
import Help from '@/pages/help/routes'
import TopUp from '@/pages/top-up/routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: { name: 'home' } // Redirect '/' to the Home route
    },
    {
      path: '/',
      component: () => import('@/components/layouts/MainLayout.vue'),
      children: [
        ...Home,
        ...ScanQR,
        ...Charger,
        ...Charging,
        ...Explore,
        ...Activity,
        ...Profile,
        ...Help,
        ...TopUp
      ]
    },
    {
      path: '/',
      component: () => import('@/components/layouts/AuthLayout.vue'),
      children: [...Login, ...Register, ...ForgotPassword, ...MaintenanceRoutes]
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'home' }
    }
  ]
})

export default router
